// Shared scope-param builder for the analytics filter panel. Maps the current
// FiltersContext selections onto the query keys the /filter/* endpoints expect,
// so the side panel's hierarchy reload and each section's lazy search build the
// exact same scope. Extracted from SidePanelOptimized so both consume one source.
import type { useFilters } from '../../../contexts/FiltersContext';

type FilterCtx = ReturnType<typeof useFilters>;

export const buildFilterParams = (ctx: FilterCtx): Record<string, string[]> => {
  const params: Record<string, string[]> = {};
  const map: Array<[Array<{ id: string }>, string]> = [
    [ctx.licenseeData, 'licensees'],
    [ctx.subCustomerData, 'customers'],
    [ctx.subCompanyData, 'subCompanies'],
    [ctx.branchData, 'branches'],
    [ctx.countryOriginData, 'originCountries'],
    [ctx.countryDestinationData, 'destinationCountries'],
    [ctx.cityOriginData, 'originCities'],
    [ctx.cityDestinationData, 'destinationCities'],
    [ctx.transportModeData, 'transportModes'],
  ];
  map.forEach(([data, paramKey]) => {
    if (data && data.length > 0) {
      params[paramKey] = data.map((item) => item.id);
    }
  });
  return params;
};
